let experimentState = {};
let _hasStartedLoadingExperiments = false;
let _hasCompletedLoadingExperiments = false;

export const EXPERIMENTS = [
  {
    title: "Next-gen player (VOD)",
    key: "useBitmovinPlayer"
  },
  {
    title: "Next-gen player (Live)",
    key: "useBitmovinPlayerLive"
  },
  {
    title: "Show player speed control",
    key: "playerShowSpeedControl"
  }
];
export const areExperimentsLoaded = () => _hasCompletedLoadingExperiments;

const loadExperiments = () => {
  if (_hasStartedLoadingExperiments) {
    return;
  }
  _hasStartedLoadingExperiments = true;

  fetch(
    `https://experiments-b.eventive.org/?f=${EXPERIMENTS.map(e => e.key).join(
      ","
    )}`
  )
    .then(r => r.json())
    .then(data => {
      console.log(`[experiments] Loaded:`, data);
      _hasCompletedLoadingExperiments = true;
      Object.assign(experimentState, data);
    })
    .catch(e => {
      console.log(`[experiments] Failed to load:`, e);
    });
};

if (typeof window !== "undefined") {
  loadExperiments();
}

export const isExperimentManuallySet = key => {
  return window.localStorage.getItem(`eventive-${key}`) !== null;
};

export const getExperimentEnabled = key => {
  try {
    // Manual local storage override
    const ls = window?.localStorage.getItem(`eventive-${key}`);
    if (ls === "1") {
      return true;
    } else if (ls === "0") {
      return false;
    }
  } catch (e) {
    // fall through
  }

  return experimentState[key];
};

export const setExperimentEnabled = (key, v) => {
  if (v === true) {
    window.localStorage.setItem(`eventive-${key}`, "1");
  } else {
    window.localStorage.setItem(`eventive-${key}`, "0");
  }
};

export const clearExperiments = () => {
  for (const e of EXPERIMENTS) {
    window.localStorage.removeItem(`eventive-${e.key}`);
  }
};
